import { ClipboardButton } from '@calendly/clipboard'
import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { ContextualBanner } from '@calendly/ui/components/contextual-banner'
import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { StepControls } from 'features/organization_settings/shared/step'
import { CopyText, HelpText, Section, SubTitle } from 'features/organization_settings/shared/styles'
import { emailSelector } from 'selectors/current_user'

import { openInNewWindowAuthorizeUrl, testSsoConnection } from './actions'
import { samlSettingsSelector } from './selectors'

export const Connection = ({
  onBackClick,
}) => {
  const dispatch = useDispatch()
  const email = useSelector(emailSelector)
  const {
    audience_url: audienceUrl,
    acs_url: acsUrl,
    default_relay_state: defaultRelayState
  } = useSelector(samlSettingsSelector)

  const onTestConnectionClick = () => {
    const url = `/users/auth/oktaoauth?state=test&email=${encodeURIComponent(email)}`
    dispatch(openInNewWindowAuthorizeUrl(url))
  }

  useEffect(
    () => {
      const onResponse = ({ data }) => dispatch(testSsoConnection(data))

      window.addEventListener('message', onResponse)
      return () => window.removeEventListener('message', onResponse)
    },
    [dispatch]
  )

  return (
    <>
      <p>{I18n.t('publisher.organization_settings.sso.connection.description')}</p>
      <Section>
        <SubTitle>{I18n.t('publisher.organization_settings.sso.connection.audience_url.label')}</SubTitle>
        <HelpText>{I18n.t('publisher.organization_settings.sso.connection.audience_url.help_text')}</HelpText>
        <ClipboardButton decoration="outline" size="small" content={audienceUrl}>
          {I18n.t('publisher.organization_settings.sso.connection.audience_url.copy')}
        </ClipboardButton>
        <CopyText>{audienceUrl}</CopyText>
      </Section>
      <Section>
        <SubTitle>{I18n.t('publisher.organization_settings.sso.connection.acs_url.label')}</SubTitle>
        <HelpText>{I18n.t('publisher.organization_settings.sso.connection.acs_url.help_text')}</HelpText>
        <ClipboardButton decoration="outline" size="small" content={acsUrl}>
          {I18n.t('publisher.organization_settings.sso.connection.acs_url.copy')}
        </ClipboardButton>
        <CopyText>{acsUrl}</CopyText>
      </Section>
      <ContextualBanner spacingTop={16} spacingBottom={16}>
        <SubTitle>{I18n.t('publisher.organization_settings.sso.connection.required_attributes.label')}</SubTitle>
        {HtmlParser(I18n.t('publisher.organization_settings.sso.connection.required_attributes.message'))}
      </ContextualBanner>
      <Section>
        <SubTitle>{I18n.t('publisher.organization_settings.sso.connection.default_relay_state.label')}</SubTitle>
        <HelpText>{I18n.t('publisher.organization_settings.sso.connection.default_relay_state.help_text')}</HelpText>
        <ClipboardButton decoration="outline" size="small" content={defaultRelayState}>
          {I18n.t('publisher.organization_settings.sso.connection.default_relay_state.copy')}
        </ClipboardButton>
        <CopyText>{defaultRelayState}</CopyText>
      </Section>
      <ContextualBanner spacingTop={16} spacingBottom={16}>
        {HtmlParser(I18n.t('publisher.organization_settings.sso.connection.testing_instructions', { email }))}
      </ContextualBanner>
      <StepControls>
        <Button decoration="ghost" onClick={onBackClick}>{I18n.t('publisher.action.go_back')}</Button>
        <Button onClick={onTestConnectionClick}>
          {I18n.t('publisher.organization_settings.sso.connection.test_connection')}
        </Button>
      </StepControls>
    </>
  )
}
